import { Subject, Subscription } from 'rxjs';
import { Component, OnInit, Input, ChangeDetectorRef, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { DataAnalyticsService } from '../../services/data-analytics.service';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';
import { ActivatedRoute, Router } from '@angular/router';
import { DataAnalyticsHelperService } from '../../services/data-analytics-helper.service';
import { takeUntil } from 'rxjs/operators';

let subscr: any = null;

@Component({
  selector: 'app-da-factory-summary',
  templateUrl: './da-factory-summary.component.html',
  styleUrls: ['./da-factory-summary.component.scss']
})
export class DaFactorySummaryComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() factorySummary: any;

  @ViewChild('myCarousel', { static: true }) myCarousel: NguCarousel<any>;
  @Input() zerobasedtarget: any;
  maxPage: number;
  carouselConfig: NguCarouselConfig = {
    grid: { xs: 3, sm: 3, md: 3, lg: 3, all: 0 },
    speed: 500,
    point: {
      visible: true,
      hideOnSingleSlide: true
    },
    touch: false,
    loop: true,
    load: 2,
    interval: { timing: 8000 },
    velocity: 0,
    easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
    RTL: false,
    vertical: {
      enabled: true,
      height: 255
    }
  };

  insigtsArray: Array<string> = [];
  insightSubscriptions: Array<Subscription> = [];

  carouselItems: any[any] = [];

  currencyData: any = {
    currencyRate: '',
    yUnit: '',
    symbolCode: '',
    label: ''
  };
  totalRange: { label: string; code: string; divisionfactor: number; };

  factorySummaryKPI = {
    totalWaste: 0,
    arrow: false,
    zeroBasedArrow: false,
    totalWastePercentage: 0,
    wasteContribution: 0,
    uniqueLine: 0,
    uniqueSKUs: 0,
    productionFrequency: 0,
    zeroBasedTargetDeviation: 0,
    zeroBasedTargetDeviationper: 0,
  };

  public message = '';
  counter = 0;
  isLoading = false;
  isLoadingInsight = false;
  moreinsightloading = false;
  lineId: string;
  lineName: string;
  insightLevel: string;
  level: string;
  factorySummarySubscription: Subscription;

  constructor(
    private daService: DataAnalyticsService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private helper: DataAnalyticsHelperService,
    private router: Router,
  ) { }

  ngOnInit() {
    subscr = this.route.queryParams.subscribe(params => {
      this.lineId = (params.LineId) ? params.LineId : null;
      this.lineName = (params.LineName) ? params.LineName : null;
      this.insightLevel = (params.level) ? params.level : null;
      if (params.level && params.factory) {
        // check if not empty
        if (this.factorySummarySubscription) {
          this.factorySummarySubscription.unsubscribe();
        }

        if (this.insightSubscriptions) {
          this.insightSubscriptions.forEach(sub => {
            sub.unsubscribe();
          });
        }
        this.getFactorySummaryKPI();
        this.getInsights();
      }
    });
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  onClickLine() {
    if (this.insightLevel === 'line') {
      const queryParamsData: any = {
        cluster: this.factorySummary.clusterId,
        factory: this.factorySummary.factoryId,
        FromDate: this.factorySummary.fromDate,
        ToDate: this.factorySummary.toDate,
        level: (this.level) ? this.level : 'factory',
      };
      if (this.level === 'factory') {
        queryParamsData.level = 'line';
        queryParamsData.LineId = null;
      }
      this.router.navigate([],
        {
          relativeTo: this.route,
          queryParams: queryParamsData,
          // queryParamsHandling: 'merge', // remove to replace all query params by provided
        }
      );
    }
  }

  getInsights() {
    this.insigtsArray = this.helper.setInsightsArr(this.insightLevel);
    const params = this.helper.setParamsForInsights(this.factorySummary, this.lineId, this.insightLevel);

    this.isLoadingInsight = true;
    this.moreinsightloading = false;
    this.message = 'Loading...';
    this.carouselItems = [];
    this.maxPage = 1;
    let count = 0;

    if (this.insigtsArray.length === 1) {
      this.moreinsightloading = false;
    }
    this.insigtsArray.forEach((url, index) => {
      setTimeout(() => {

        this.isLoadingInsight = true;
        // this.moreinsightloading = true;
        this.insightSubscriptions[index] = this.daService.getInsight(url, params)
          .subscribe(res => {
            count++;

            if (res && res.length > 0) {
              const content = res.join(' ');
              this.carouselItems.push({ content });

              this.maxPage = Math.ceil(this.carouselItems.length / 3);


              if (this.carouselItems.length === 1) {

                this.isLoadingInsight = false;
                this.moreinsightloading = true;
              } else {
                this.moreinsightloading = false;
              }
              // else if (this.carouselItems.length === 1 && count === 1) {
              //   console.log(111);
              //   this.moreinsightloading = false;
              // }


            }
            if (count === this.insigtsArray.length) {

              this.isLoadingInsight = false;
              this.moreinsightloading = false;

              if (this.carouselItems && this.carouselItems.length === 0) {
                this.isLoadingInsight = true;
                this.message = 'Data not available.';
              }
              setTimeout(() => {
                this.myCarousel.reset();
                this.counter = 0;
              }, 1000);
            }
          });

      }, 1000);
    });
  }

  getFactorySummaryKPI() {

    this.factorySummaryKPI = {
      totalWaste: 0,
      arrow: false,
      zeroBasedArrow: false,
      totalWastePercentage: 0,
      wasteContribution: 0,
      uniqueLine: 0,
      uniqueSKUs: 0,
      productionFrequency: 0,
      zeroBasedTargetDeviation: 0,
      zeroBasedTargetDeviationper: 0,
    };

    this.isLoading = true;
    const params: any = {
      ClusterId: this.factorySummary.clusterName,
      FactoryId: this.factorySummary.factoryId,
      FromDate: this.factorySummary.fromDate,
      ToDate: this.factorySummary.toDate,
      Level: this.insightLevel,
    };

    if (this.lineId) {
      params.LineId = this.lineId;
    }

    this.factorySummarySubscription = this.daService.getFactorySummaryFunction(params)
      .subscribe((res: any) => {
        if (res && res.result) {
          let totalWastePercentage = 0;
          if (res.result.prevWaste !== 0) {
            totalWastePercentage = Math.abs(Number((((res.result.totalWaste - res.result.prevWaste) /
              res.result.prevWaste) * 100).toFixed(2)));
          }
          let zeroBasedTargetDeviationper = 0;
          if (res.result.previousZeroBasedTargetDeviation !== 0) {
            zeroBasedTargetDeviationper = Math.abs(Number((res.result.zeroBasedTargetDeviation - res.result.previousZeroBasedTargetDeviation).toFixed(2)));
            console.log(zeroBasedTargetDeviationper);
          }
          this.factorySummaryKPI = {
            totalWaste: res.result.totalWaste,
            arrow: this.setArrow(res.result.totalWaste, res.result.prevWaste),
            zeroBasedArrow: this.setArrow(res.result.zeroBasedTargetDeviation, res.result.previousZeroBasedTargetDeviation),
            totalWastePercentage,
            wasteContribution: 0,
            uniqueLine: res.result.uniqueLines,
            uniqueSKUs: res.result.uniqueSkus,
            productionFrequency: res.result.productionFrequency,
            zeroBasedTargetDeviation: res.result.zeroBasedTargetDeviation,
            zeroBasedTargetDeviationper,
          };
          if (this.insightLevel === 'factory') {
            this.factorySummaryKPI.wasteContribution = (res.result.totalWaste / Math.abs(res.result.totalClusterWaste)) * 100;
          } else {
            this.factorySummaryKPI.wasteContribution = (res.result.totalWaste / Math.abs(res.result.totalFactoryWaste)) * 100;
          }
          this.isLoading = false;
        } else {
          this.factorySummaryKPI = {
            totalWaste: 0,
            arrow: false,
            zeroBasedArrow: false,
            totalWastePercentage: 0,
            wasteContribution: 0,
            uniqueLine: 0,
            uniqueSKUs: 0,
            productionFrequency: 0,
            zeroBasedTargetDeviation: 0,
            zeroBasedTargetDeviationper: 0,
          };
          this.isLoading = false;
        }
      });
  }

  onChangeDate(start, end) {
    this.factorySummary.fromDate = start;
    this.factorySummary.toDate = end;
    this.insightSubscriptions.forEach(sub => {
      sub.unsubscribe();
    });
    this.counter = 0;
    this.getFactorySummaryKPI();
    this.getInsights();
  }


  setArrow(total: number, prev: number) {
    if (total > prev) {
      return false;
    }
    return true;
  }

  onNext() {
    if (this.counter !== this.maxPage) {
      this.counter++;
      this.myCarousel.moveTo(this.counter);
    }
  }

  onPrevious() {
    if (this.counter >= 0) {
      this.counter--;
      this.myCarousel.moveTo(this.counter);
    }
  }

  onmoveFn(event) {
    if (this.carouselItems.length > 3) {
      this.counter = Math.ceil(event.currentSlide / event.items);
      if (event.isFirst) {
        this.counter = 0;
      }
    }
  }

  ngOnDestroy(): void {
    if (subscr) {
      subscr.unsubscribe();
    }
    this.daService.clearSelectedDA();
    if (this.factorySummarySubscription) {
      this.factorySummarySubscription.unsubscribe();
    }

    if (this.insightSubscriptions) {
      this.insightSubscriptions.forEach(sub => {
        sub.unsubscribe();
      });
    }
  }

}
